module.exports = __webpack_public_path__ + "static/google-ebdda521bb5332bcd0f18ae0c0a2dc1f.png";